import React, { useState } from 'react'
import BookAppointment from './BookAppointment';
import IVFExperts from './IVFExperts';
import Specialities from './Specialities';
import CenterofExcellence from './CenterofExcellence';
import OurDoctors from './OurDoctors'
//import FAQs from './FAQs';
import you from '../../assets/images/boy.png'
import LastMenu from "../ChatFlow/Lastmenu";
import Lastmenu from './Lastmenu';
import Locations from './Locations';

const Mainmenu = ({ name: initialName, mobile: initialMobile}) => {
  const [name, setName] = useState(initialName || "");
  const [mobile, setMobile] = useState(initialMobile || "");
  
  const [time1,setTime1] = React.useState(new Date());
  
  const [showMenu, setShowMenu] = useState(true);

  const [activeFrames, setActiveFrames] = useState([{ id: 1, component: "Mainmenu" }]); // Root frame

  const handleShowFrame = (parentId, frameName) => {
    setShowMenu(false);
    setTime1(new Date());
    setActiveFrames((prevFrames) => [
      ...prevFrames,
      { id: prevFrames.length + 1, parentId, component: frameName },
    ]);
  };
  
  const renderFrame = (frame) => {
    let FrameComponent = null;
    switch (frame.component) {
      case "BookAppointment":
  return (
    <div key={frame.id}>
      <div className="you-time">
        <img src={you} alt="boy" className="boy" />
        You {time1?.toLocaleTimeString()}
      </div>
      <div className="you-message">
        <div className="frame2">BookAppointment</div>
      </div>
      <BookAppointment
        doctorId={null} // or pass if available
        name={name}
        mobile={mobile}
        handleShowFrame={handleShowFrame}
        parentId={frame.id}
      />
    </div>
  );
      case "IVFExperts":
        return (
          <div key={frame.id}>
            <div className="you-time">
              <img src={you} alt="boy" className="boy" />
              You {time1?.toLocaleTimeString()}
            </div>
            <div className="you-message">
              <div className="frame2">BookAppointment</div>
            </div>
            <IVFExperts
              doctorId={null} // or pass if available
              name={name}
              mobile={mobile}
              handleShowFrame={handleShowFrame}
              parentId={frame.id}
            />
          </div>
        );
      case "Specialities":
        FrameComponent =Specialities;
        break;
        case "Locations":
        FrameComponent =Locations;
        break;
        case "Center of Excellence":
          FrameComponent =CenterofExcellence;
          break;  
        case "OurDoctors":
            FrameComponent =OurDoctors;
            break;
      case "InternationalPatients":
        return(
          <>
          <div className="you-time">
            <img src={you} alt="boy" className="boy" />
            You {time1?.toLocaleTimeString()}
          </div>
          <div className='you-message'>
            <div className='frame2'>International Patients</div>
          </div>
            <Lastmenu />
          </>
        );

        case "CollectReports":
        return(
          <>
          <div className="you-time">
            <img src={you} alt="boy" className="boy" />
            You {time1?.toLocaleTimeString()}
          </div>
          <div className='you-message'>
            <div className='frame2'>Collect Reports</div>
          </div>
            <Lastmenu />
          </>
        );
        case "BookHealthPackages":
          return(
            <>
            <div className="you-time">
              <img src={you} alt="boy" className="boy" />
              You {time1?.toLocaleTimeString()}
            </div>
            <div className='you-message'>
              <div className='frame2'>Book Health Packages</div>
            </div>
              <Lastmenu />
            </>
          );
          case "CheckDoctorsAvailability":
            return(
              <>
              <div className="you-time">
                <img src={you} alt="boy" className="boy" />
                You {time1?.toLocaleTimeString()}
              </div>
              <div className='you-message'>
                <div className='frame2'>Check Doctors Availability</div>
              </div>
                <Lastmenu />
              </>
            );
            case "Emergency":
            return(
              <>
              <div className="you-time">
                <img src={you} alt="boy" className="boy" />
                You {time1?.toLocaleTimeString()}
              </div>
              <div className='you-message'>
                <div className='frame2'>Emergency</div>
              </div>
                <Lastmenu />
              </>
            );
            case "StarMember":
              return(
                <>
                <div className="you-time">
                  <img src={you} alt="boy" className="boy" />
                  You {time1?.toLocaleTimeString()}
                </div>
                <div className='you-message'>
                  <div className='frame2'>Star Member</div>
                </div>
                  <Lastmenu />
                </>
              );
              case "Careers":
                return(
                  <>
                  <div className="you-time">
                    <img src={you} alt="boy" className="boy" />
                    You {time1?.toLocaleTimeString()}
                  </div>
                  <div className='you-message'>
                    <div className='frame2'>Careers</div>
                  </div>
                    <Lastmenu />
                  </>
                );
                case "Corporate":
                  return(
                    <>
                    <div className="you-time">
                      <img src={you} alt="boy" className="boy" />
                      You {time1?.toLocaleTimeString()}
                    </div>
                    <div className='you-message'>
                      <div className='frame2'>Corporate</div>
                    </div>
                      <Lastmenu />
                    </>
                  );
        
      case "SuccessStories":
        return(
          <>
             <div className="you-time">
            <img src={you} alt="boy" className="boy" />
            You {time1?.toLocaleTimeString()}
          </div>
          <div className='you-message'>
            <div className='frame2'>Success Stories</div>
          </div>
            <Lastmenu />
          </>
        );
        
      case "ReferaFriend":
        return(
          <>
             <div className="you-time">
            <img src={you} alt="boy" className="boy" />
            You {time1?.toLocaleTimeString()}
          </div>
          <div className='you-message'>
            <div className='frame2'>Refer a Friend</div>
          </div>
            <Lastmenu />
          </>
        );
          
      
      case "FAQ's":
       // FrameComponent = FAQs;
        break;
      default:
        return null;
    }
  
    return (
      <div key={frame.id}>
        <div className="you-time">
          <img src={you} alt="boy" className="boy" />
          You {time1?.toLocaleTimeString()}
        </div>
        <div className="you-message">
          <div className="frame2">{frame.component}</div>
        </div>
        <FrameComponent handleShowFrame={handleShowFrame}  name={name}
        mobile={mobile}  parentId={frame.id} />
      </div>
    );
  };
  
  return (
    <div style={{ marginBottom: '10px' }}>
      
        <div className='frame1 animated-frame'>
            👋 Hi there! How can I assist you today?<br />
            Choose an option below to get started.
        </div>

        {
            showMenu &&
            <div className='menu-btns animated-frame'>
                <button className='menu-btn' onClick={() => handleShowFrame(7, "Locations")}>Locations</button>
                <a href="tel:040-68334455" target="_blank" rel="noopener noreferrer " style={{ textDecoration: 'none' }}><button className='menu-btn' onClick={() => handleShowFrame(5, "Emergency")}>Emergency</button></a>
                <button className='menu-btn' onClick={() => handleShowFrame(2, "BookAppointment")}>Book an Appointment</button>
                <button className='menu-btn' onClick={() => handleShowFrame(3, "CollectReports")}>Collect Reports</button>
                <button className='menu-btn' onClick={() => handleShowFrame(4, "BookHealthPackages")}>Book Health Packages</button>
                <button className='menu-btn' onClick={() => handleShowFrame(8, "OurDoctors")}>Our Doctors</button>
                <button className='menu-btn' onClick={() => handleShowFrame(2, "CheckDoctorsAvailability")}>Check Doctors Availability</button>
                <a href="https://www.medicoverhospitals.in/international-patient-services" target="_blank" rel="noopener noreferrer"><button className='menu-btn' onClick={() => handleShowFrame(5, "InternationalPatients")}>International Patients</button></a>
                <button className='menu-btn' onClick={() => handleShowFrame(7, "Specialities")}>Specialities</button>
                <button className='menu-btn' onClick={() => handleShowFrame(8, "Center of Excellence")}>Center of Excellence</button>
                <button className='menu-btn' onClick={() => handleShowFrame(9, "StarMember")}>Medicover Member</button>
                <button className='menu-btn' onClick={() => handleShowFrame(8, "Careers")}>Careers</button>
                <button className='menu-btn' onClick={() => handleShowFrame(9, "Corporate")}>Corporate</button>
            </div>
        }
        {activeFrames.slice(1).map(renderFrame)}
    </div>
    
  )
}

export default Mainmenu